// extracted by mini-css-extract-plugin
module.exports = {"root":"InstrumentFilter_root__2WOPN","active":"InstrumentFilter_active__2K6oO"};